<template>
    <a :href=getlink()
       class="link-mini-category"
    >
        <span>
            {{ getName() }}
        </span>
    </a>
</template>


<script>
    import Product from './Product';
    import Filters from './Filters';
    import {mapGetters} from 'vuex'
    import * as types from '../store/types';


    export default {
        name: 'CategoryMini',
        components: {
            Product,
            Filters,
        },
        props: {
            category: {}
        },
        methods: {
            isActive() {
                return parseInt(this.category.active);
            },
            getName() {
                return this.category.name;
            },
            getlink() {
                return this.getHostname() + this.category.id + '-' + this.category.link_rewrite;
            },
            getDescription() {
                return this.category.description;
            },
            ...mapGetters({
                getHostname: types.GET_HOSTNAME,
            }),
        },
    }
</script>


<style scoped>

    .card-category {
        margin: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/CategoryMini.vue